import { Component, OnInit, OnDestroy, Output, EventEmitter, Input, HostListener } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { IxellAPIService, Application, SearchResponseVariants } from '../../tools/api.service';
import { Utils } from '../../tools/utils';
import { SearchResponseMarket, Results } from '../../tools/api.service';
import { ColorGroup } from 'src/app/entities/ColorGroup';
import { StorageService } from 'src/app/tools/storage.service';
import { Message } from '../../entities/message';
import { SearchCritMixitCloud } from '../../entities/searchCritMixitCloud';
import { HeaderService } from 'src/app/tools/header.service';
import { SearchResultMixitCloud } from '../../entities/searchResultMixitCloud';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'searchMixitCloud',
    templateUrl: './searchMixitCloud.component.html',
    styleUrls: ['./searchMixitCloud.component.scss']
})

export class SearchMixitCloudComponent implements OnInit, OnDestroy {
    @Input() colorCode: string;
    @Input() manufacturer: string;
    @Input() country: string;
    @Input() langue: string;
    @Input() searchCrit: SearchCritMixitCloud;
    @Input() teintesMeres: Results[];
    @Input() teinteAccessoire: Results;
    @Input() teintesMeresAccessoire: Results[];
    @Input() seeFiltreColorWebTech: boolean;
    @Input() applicationAccessoire: boolean;
    @Input() infoAccessoire: string;
    @Input() selectedPart: string;
    @Input() listApplicationAccessoire: string[];

    @Input() seeMultiTon: boolean;
    @Input() teinteMultiTon: Results;
    @Input() teintesMeresMultiTon: Results[];
    @Input() infoMultiTon: string;

    @Output() listResultTeintesMeres = new EventEmitter<SearchResultMixitCloud>();
    @Output() listResultVariantes = new EventEmitter<SearchResultMixitCloud>();

    @Output() resultTeintesMeresAccessoire = new EventEmitter<Results>();
    @Output() listResultTeintesMeresAccessoire = new EventEmitter<Results[]>();
    @Output() outputSelectedPart = new EventEmitter<string>();
    @Output() outputListApplicationAccessoire = new EventEmitter<string[]>();

    @Output() outputResultTeintesMeresMultiTon = new EventEmitter<Results>();
    @Output() outputListResultTeintesMeresMultiTon = new EventEmitter<Results[]>();

    @Output() outputLangue = new EventEmitter();

    Utils = Utils;

    variantes: SearchResponseVariants;
    listCode: string[] = [];

    selectedPaintLine: string = "equinox";

    searchMixitCloudForm: UntypedFormGroup;

    breakpoint: number;
    heightSize: string;

    private colorSub: any;
    private manufacturerSub: any;
    private modelSub: any;
    private searchSub: any;

    constructor(private headerService: HeaderService, private formBuilder: UntypedFormBuilder, private router: Router, private apiService: IxellAPIService, private storage: StorageService) {
    }

    @HostListener('window:popstate', ['$event'])
    onPopState(event: any) {
        this.headerService.changeBack(true);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * ngOnInit
     */
    ngOnInit() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("ngOnInit searchMixitCloud");
        ///*----------------------------------------------------------------------------------------------------*/console.log("this.searchCrit", this.searchCrit);

        window.onpopstate = function () {
        };

        this.outputLangue.emit();

        ///*----------------------------------------------------------------------------------------------------*/console.log("this.searchCrit", this.searchCrit);

        this.searchMixitCloudForm = this.formBuilder.group({
            colorCode: new UntypedFormControl({ value: this.searchCrit.colorCode, disabled: false }),
            manufacturer: new UntypedFormControl({ value: this.searchCrit.manufacturer, disabled: false }),
            model: new UntypedFormControl({ value: this.searchCrit.model, disabled: true }),
            year: new UntypedFormControl({ value: this.searchCrit.year, disabled: true }),
            colorGroup: new UntypedFormControl({ value: this.searchCrit.colorGroup, disabled: false }),
            application: new UntypedFormControl({ value: '', disabled: false })
            //applicationAccessoire: new UntypedFormControl({ value: '', disabled: false })
        });

        if (!this.searchCrit.listConstructeur || (this.searchCrit.listConstructeur && this.searchCrit.listConstructeur.length == 0)) {
            this.openLoader();

            ///*----------------------------------------------------------------------------------------------------*/console.log(this.searchMixitCloudForm.value.colorCode);
            ///*----------------------------------------------------------------------------------------------------*/console.log(this.searchMixitCloudForm.value.manufacturer);

            this.manufacturerSub = this.apiService.updateFiltreMixiCloud("", "", "", "", "", this.country, this.langue).subscribe(data => {

                ///*----------------------------------------------------------------------------------------------------*/console.log("updateFiltreMixiCloud");
                ///*----------------------------------------------------------------------------------------------------*/console.log(data);

                this.searchCrit.listConstructeur = data.brands;
                this.searchCrit.listGroupeCouleur = data.colorGroups;
                this.searchCrit.listGroupeCouleurInitial = data.colorGroups;
                this.searchCrit.listApplication = data.parts;
                if (this.manufacturerSub != null) this.manufacturerSub.unsubscribe();



                //this.searchMixitCloudForm.get("manufacturer").valueChanges.subscribe(x => {
                //    console.log('firstname value changed');
                //    console.log(x);
                //});
                //this.searchMixitCloudForm.controls['manufacturer'].setValue(this.manufacturer);

                /* execute la recherche en provenance de Colorbook => les valeur colorcode et manufacturer sont deja dans le searchCrit (issu du global) */
                if (this.colorCode != null && this.colorCode != "") {
                    this.colorCode = null;
                    if (this.manufacturer != null && this.manufacturer != "")
                        this.manufacturer = null;
                    this.search();
                    this.closeLoader();
                } else {
                    this.closeLoader();
                }
            },
                error => {
                    this.closeLoader();
                    console.log(error);
                    if (this.manufacturerSub != null) this.manufacturerSub.unsubscribe();
                });
        } else {
            if (this.searchCrit.selectedConstructeur) {
                this.searchMixitCloudForm.controls["model"].enable();
            }
            if (this.searchCrit.selectedModele) {
                this.searchMixitCloudForm.controls["year"].enable();
            }
        }

        this.breakpoint = 5;
        this.heightSize = "320";

        if (window.innerWidth <= 920) {
            this.breakpoint = 1;
        }
        else {
            this.breakpoint = 5;
            //this.breakpoint = Math.round(window.innerWidth / 288);
        }
        //this.heightSize = (window.innerWidth <= 600) ? "4:3" : "6:1";

        this.searchCrit

    }

/* ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- */
/* Search */
/* ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- */

    //#region Search

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * searchColorCode
     */
    searchColorCode() {
        this.outputLangue.emit();

       if (this.searchMixitCloudForm.controls['colorCode'].value.length >= 2) {
            this.colorSub = this.apiService.getLstCodeMixitCloud(this.searchMixitCloudForm.controls['colorCode'].value, this.country, this.langue).subscribe(data => {
                ///*----------------------------------------------------------------------------------------------------*/console.log(data);
                this.listCode = data;
                if (this.colorSub != null) this.colorSub.unsubscribe();
            },
            error => {
                console.log(error);
                if (this.colorSub != null) this.colorSub.unsubscribe();
            });
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * search
     */
    search() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function search");

        this.outputLangue.emit();

        document.getElementById("errorlbl").style.visibility = "hidden";
        if (this.searchMixitCloudForm.value.colorGroup == "0") this.searchMixitCloudForm.value.colorGroup = "";
        if (this.searchMixitCloudForm.value.colorCode == null) this.searchMixitCloudForm.value.colorCode = "";
        if (this.searchMixitCloudForm.value.year == null) this.searchMixitCloudForm.value.year = "";

        if (this.searchMixitCloudForm.value.colorCode != "" || this.searchMixitCloudForm.value.colorGroup != "" || this.searchMixitCloudForm.value.manufacturer != "" || this.searchMixitCloudForm.value.model != "" || this.searchMixitCloudForm.value.year != "") {

            this.searchCrit.colorCode = this.searchMixitCloudForm.value.colorCode;
            this.searchCrit.colorGroup = this.searchMixitCloudForm.value.colorGroup;
            this.searchCrit.manufacturer = this.searchMixitCloudForm.value.manufacturer;
            this.searchCrit.model = this.searchMixitCloudForm.value.model;
            this.searchCrit.year = this.searchMixitCloudForm.value.year;

            this.openLoader();
            this.searchSub = this.apiService.searchFormulesMeresMixitCloud(this.searchMixitCloudForm.value.colorCode, this.searchMixitCloudForm.value.manufacturer, this.searchMixitCloudForm.value.model, this.searchMixitCloudForm.value.year, this.searchMixitCloudForm.value.colorGroup, this.country, this.langue, 0, false).subscribe(data => {

                this.searchCrit.positionInSearch = data.results.length;

                var teintesMeresFiltrer: Results[] = [];
                for (var i = 0; i < data.results.length; i++) {
                    if ((data.results[i].codesCar && data.results[i].codesCar.length > 0 && data.results[i].codesCar.findIndex(x => x.toLowerCase().indexOf(this.searchMixitCloudForm.value.colorCode.toLowerCase()) > -1) > -1)
                        || ( ((data.results[i].combinationOf && data.results[i].combinationOf.length == 0) || (!data.results[i].combinationOf))
                            && data.results[i].colorDescription && data.results[i].colorDescription.toLowerCase().indexOf(this.searchMixitCloudForm.value.colorCode.toLowerCase()) > -1)
                    )
                    {
                        teintesMeresFiltrer.push(data.results[i]);
                    }
                }
                data.results = teintesMeresFiltrer;
                
                let res: SearchResultMixitCloud = new SearchResultMixitCloud();
                res.crit = this.searchCrit;
                res.teintesMeres = data;
                this.teintesMeres = data.results;
                this.searchCrit.lengthTotalSearch = data.count;
                //this.searchCrit.positionInSearch = data.results.length;
                if (data != null) {
                    this.listResultTeintesMeres.emit(res);
                }
                else
                    document.getElementById("errorlbl").style.visibility = "visible";
                if (this.searchSub != null) this.searchSub.unsubscribe();
                this.closeLoader();

                if (this.teintesMeres.length == 0) {
                    this.CompleteSearchAsync();
                }
            },
            error => {
                console.log(error);
                if (this.searchSub != null) this.searchSub.unsubscribe();
                this.closeLoader();
            });
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * completeSearch
     */
    async CompleteSearchAsync() {
        this.outputLangue.emit();

        var breakLoop = 0;
        while (this.teintesMeres.length == 0) {
            ///*----------------------------------------------------------------------------------------------------*/console.log("test while CompleteSearchAsync");

            document.getElementById("errorlbl").style.visibility = "hidden";
            if (this.searchMixitCloudForm.value.colorGroup == "0") this.searchMixitCloudForm.value.colorGroup = "";
            if (this.searchMixitCloudForm.value.colorCode == null) this.searchMixitCloudForm.value.colorCode = "";
            if (this.searchMixitCloudForm.value.year == null) this.searchMixitCloudForm.value.year = "";

            if (this.searchMixitCloudForm.value.colorCode != "" || this.searchMixitCloudForm.value.colorGroup != "" || this.searchMixitCloudForm.value.manufacturer != "" || this.searchMixitCloudForm.value.model != "" || this.searchMixitCloudForm.value.year != "") {

                this.searchCrit.colorCode = this.searchMixitCloudForm.value.colorCode;
                this.searchCrit.colorGroup = this.searchMixitCloudForm.value.colorGroup;
                this.searchCrit.manufacturer = this.searchMixitCloudForm.value.manufacturer;
                this.searchCrit.model = this.searchMixitCloudForm.value.model;
                this.searchCrit.year = this.searchMixitCloudForm.value.year;

                this.openLoader();

                var dataSearchFormulesMeresMixitCloudAsync = await firstValueFrom(
                    this.apiService.searchFormulesMeresMixitCloud(this.searchMixitCloudForm.value.colorCode, this.searchMixitCloudForm.value.manufacturer, this.searchMixitCloudForm.value.model, this.searchMixitCloudForm.value.year, this.searchMixitCloudForm.value.colorGroup, this.country, this.langue, this.searchCrit.positionInSearch, false)
                );

                this.searchCrit.positionInSearch += dataSearchFormulesMeresMixitCloudAsync.results.length;

                var teintesMeresFiltrer: Results[] = [];
                for (var i = 0; i < dataSearchFormulesMeresMixitCloudAsync.results.length; i++) {
                    if ((dataSearchFormulesMeresMixitCloudAsync.results[i].codesCar && dataSearchFormulesMeresMixitCloudAsync.results[i].codesCar.length > 0 && dataSearchFormulesMeresMixitCloudAsync.results[i].codesCar.findIndex(x => x.toLowerCase().indexOf(this.searchMixitCloudForm.value.colorCode.toLowerCase()) > -1) > -1)
                        || (((dataSearchFormulesMeresMixitCloudAsync.results[i].combinationOf && dataSearchFormulesMeresMixitCloudAsync.results[i].combinationOf.length == 0) || (!dataSearchFormulesMeresMixitCloudAsync.results[i].combinationOf))
                            && dataSearchFormulesMeresMixitCloudAsync.results[i].colorDescription && dataSearchFormulesMeresMixitCloudAsync.results[i].colorDescription.toLowerCase().indexOf(this.searchMixitCloudForm.value.colorCode.toLowerCase()) > -1)
                        //|| (dataSearchFormulesMeresMixitCloudAsync.results[i].colorDescription && dataSearchFormulesMeresMixitCloudAsync.results[i].colorDescription.toLowerCase().indexOf(this.searchMixitCloudForm.value.colorCode.toLowerCase()) > -1)
                    )
                    {
                        teintesMeresFiltrer.push(dataSearchFormulesMeresMixitCloudAsync.results[i]);
                    }
                }
                dataSearchFormulesMeresMixitCloudAsync.results = teintesMeresFiltrer;

                ///*----------------------------------------------------------------------------------------------------*/console.log("this.teintesMeres");
                ///*----------------------------------------------------------------------------------------------------*/console.log(this.teintesMeres);
                ///*----------------------------------------------------------------------------------------------------*/console.log("data.results");
                ///*----------------------------------------------------------------------------------------------------*/console.log(data.results);
                ///*----------------------------------------------------------------------------------------------------*/console.log("this.teintesMeres.concat(data.results)");
                ///*----------------------------------------------------------------------------------------------------*/console.log(this.teintesMeres.concat(data.results));

                for (var i = 0; i < dataSearchFormulesMeresMixitCloudAsync.results.length; i++) {
                    this.teintesMeres.push(dataSearchFormulesMeresMixitCloudAsync.results[i]);
                }
                ///*----------------------------------------------------------------------------------------------------*/console.log("this.teintesMeres");
                ///*----------------------------------------------------------------------------------------------------*/console.log(this.teintesMeres);
                //this.teintesMeres = this.teintesMeres.concat(data.results);
                this.searchCrit.lengthTotalSearch = dataSearchFormulesMeresMixitCloudAsync.count;
                //this.searchCrit.positionInSearch += data.results.length;

                let res: SearchResultMixitCloud = new SearchResultMixitCloud();
                res.crit = this.searchCrit;
                res.teintesMeres = dataSearchFormulesMeresMixitCloudAsync;
                res.teintesMeres.results = this.teintesMeres;

                if (dataSearchFormulesMeresMixitCloudAsync != null) {
                    this.listResultTeintesMeres.emit(res);
                }
                else
                    document.getElementById("errorlbl").style.visibility = "visible";
                if (this.searchSub != null) this.searchSub.unsubscribe();
                this.closeLoader();
            }

            if (breakLoop == 5 || this.teintesMeres.length != 0) {
                break;
            }
            breakLoop++;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * completeSearch
     */
    CompleteSearch() {
        this.outputLangue.emit();

        document.getElementById("errorlbl").style.visibility = "hidden";
        if (this.searchMixitCloudForm.value.colorGroup == "0") this.searchMixitCloudForm.value.colorGroup = "";
        if (this.searchMixitCloudForm.value.colorCode == null) this.searchMixitCloudForm.value.colorCode = "";
        if (this.searchMixitCloudForm.value.year == null) this.searchMixitCloudForm.value.year = "";

        if (this.searchMixitCloudForm.value.colorCode != "" || this.searchMixitCloudForm.value.colorGroup != "" || this.searchMixitCloudForm.value.manufacturer != "" || this.searchMixitCloudForm.value.model != "" || this.searchMixitCloudForm.value.year != "") {

            this.searchCrit.colorCode = this.searchMixitCloudForm.value.colorCode;
            this.searchCrit.colorGroup = this.searchMixitCloudForm.value.colorGroup;
            this.searchCrit.manufacturer = this.searchMixitCloudForm.value.manufacturer;
            this.searchCrit.model = this.searchMixitCloudForm.value.model;
            this.searchCrit.year = this.searchMixitCloudForm.value.year;

            this.openLoader();
            this.searchSub = this.apiService.searchFormulesMeresMixitCloud(this.searchMixitCloudForm.value.colorCode, this.searchMixitCloudForm.value.manufacturer, this.searchMixitCloudForm.value.model, this.searchMixitCloudForm.value.year, this.searchMixitCloudForm.value.colorGroup, this.country, this.langue, this.searchCrit.positionInSearch, false).subscribe(data => {
                ///*----------------------------------------------------------------------------------------------------*/console.log(data);
                ///*----------------------------------------------------------------------------------------------------*/console.log(data.results);

                this.searchCrit.positionInSearch += data.results.length;

                var teintesMeresFiltrer: Results[] = [];
                for (var i = 0; i < data.results.length; i++) {
                    if ((data.results[i].codesCar && data.results[i].codesCar.length > 0 && data.results[i].codesCar.findIndex(x => x.toLowerCase().indexOf(this.searchMixitCloudForm.value.colorCode.toLowerCase()) > -1) > -1)
                        || (((data.results[i].combinationOf && data.results[i].combinationOf.length == 0) || (!data.results[i].combinationOf))
                            && data.results[i].colorDescription && data.results[i].colorDescription.toLowerCase().indexOf(this.searchMixitCloudForm.value.colorCode.toLowerCase()) > -1)
                    )
                    {
                        teintesMeresFiltrer.push(data.results[i]);
                    }
                }
                data.results = teintesMeresFiltrer;

                ///*----------------------------------------------------------------------------------------------------*/console.log("this.teintesMeres");
                ///*----------------------------------------------------------------------------------------------------*/console.log(this.teintesMeres);
                ///*----------------------------------------------------------------------------------------------------*/console.log("data.results");
                ///*----------------------------------------------------------------------------------------------------*/console.log(data.results);
                ///*----------------------------------------------------------------------------------------------------*/console.log("this.teintesMeres.concat(data.results)");
                ///*----------------------------------------------------------------------------------------------------*/console.log(this.teintesMeres.concat(data.results));

                for (var i = 0; i < data.results.length; i++) {
                    this.teintesMeres.push(data.results[i]);
                }
                ///*----------------------------------------------------------------------------------------------------*/console.log("this.teintesMeres");
                ///*----------------------------------------------------------------------------------------------------*/console.log(this.teintesMeres);
                //this.teintesMeres = this.teintesMeres.concat(data.results);
                this.searchCrit.lengthTotalSearch = data.count;
                //this.searchCrit.positionInSearch += data.results.length;

                let res: SearchResultMixitCloud = new SearchResultMixitCloud();
                res.crit = this.searchCrit;
                res.teintesMeres = data;
                res.teintesMeres.results = this.teintesMeres;

                if (data != null) {
                    this.listResultTeintesMeres.emit(res);
                }
                else
                    document.getElementById("errorlbl").style.visibility = "visible";
                if (this.searchSub != null) this.searchSub.unsubscribe();
                this.closeLoader();
            },
            error => {
                console.log(error);
                if (this.searchSub != null) this.searchSub.unsubscribe();
                this.closeLoader();
            });
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * SelectVariantesOrMulti
     * @param teinte
     */
    SelectVariantesOrMulti(teinte: Results, isMulti: boolean = false) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("SelectVariantes");
        ///*----------------------------------------------------------------------------------------------------*/console.log(this.teintesMeresAccessoire);
        if (isMulti) {
            this.SelectMultiTon(teinte);
        } else {
            this.outputLangue.emit();

            document.getElementById("errorlbl").style.visibility = "hidden";

            this.openLoader();
            this.searchSub = this.apiService.searchVariantesMixitCloud(teinte.marketColorId, this.country, this.langue).subscribe(data => {
                ///*----------------------------------------------------------------------------------------------------*/console.log(data);
                let res: SearchResultMixitCloud = new SearchResultMixitCloud();
                res.crit = this.searchCrit;
                res.variantes = data;
                res.teintesMeres = new SearchResponseMarket();
                res.teintesMeres.results = [];
                res.teintesMeres.results.push(teinte);
                this.variantes = data;
                if (data != null) {
                    this.listResultVariantes.emit(res);
                }
                else
                    document.getElementById("errorlbl").style.visibility = "visible";
                if (this.searchSub != null) this.searchSub.unsubscribe();
                this.closeLoader();
            },
            error => {
                console.log(error);
                if (this.searchSub != null) this.searchSub.unsubscribe();
                this.closeLoader();
            });
        }
    }

    //#endregion Search


/* ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- */
/* Filtre */
/* ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- */

    //#region Filtre

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * SelectConstructeur
     */
    SelectConstructeur() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("SelectConstructeur");
        this.outputLangue.emit();

        this.searchCrit.selectedConstructeur = true;
        this.openLoader();
        this.modelSub = this.apiService.updateFiltreMixiCloud(this.searchMixitCloudForm.value.colorCode, this.searchMixitCloudForm.value.manufacturer, "", "", this.searchMixitCloudForm.value.colorGroup, this.country, this.langue).subscribe(data => {
            ///*----------------------------------------------------------------------------------------------------*/console.log(data);
            this.searchCrit.listModele = data.models;
            this.searchCrit.listGroupeCouleur = data.colorGroups;
            this.searchCrit.listGroupeCouleurConstructeur = data.colorGroups;
            if (this.modelSub != null) this.modelSub.unsubscribe();
            this.closeLoader();
        },
        error => {
            console.log(error);
            if (this.modelSub != null) this.modelSub.unsubscribe();
            this.closeLoader();
        });

        this.searchMixitCloudForm.controls["model"].setValue("");
        this.searchMixitCloudForm.controls["model"].enable();
        this.searchMixitCloudForm.controls["year"].setValue("");
        this.searchMixitCloudForm.controls["year"].disable();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * ClearConstructeurs
     * @param event
     */
    ClearConstructeurs(event: any) {
        this.searchMixitCloudForm.controls["manufacturer"].setValue("");
        this.searchMixitCloudForm.controls["model"].setValue("");
        this.searchMixitCloudForm.controls["model"].disable();
        this.searchMixitCloudForm.controls["year"].setValue("");
        this.searchMixitCloudForm.controls["year"].disable();
        this.searchCrit.listModele = [];
        this.searchCrit.listAnnee = [];
        this.searchCrit.listGroupeCouleur = this.searchCrit.listGroupeCouleurInitial;
        event.stopPropagation();
        this.searchCrit.selectedConstructeur = false;
        this.searchCrit.selectedModele = false;
        this.searchCrit.selectedAnnee = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * SelectModele
     */
    SelectModele() {
        this.outputLangue.emit();

        this.searchCrit.selectedModele = true;
        this.openLoader();
        this.modelSub = this.apiService.updateFiltreMixiCloud(this.searchMixitCloudForm.value.colorCode, this.searchMixitCloudForm.value.manufacturer, this.searchMixitCloudForm.value.model, "", this.searchMixitCloudForm.value.colorGroup, this.country, this.langue).subscribe(data => {

            ///*----------------------------------------------------------------------------------------------------*/console.log(data);

            this.searchCrit.listAnnee = data.colorsUsedInYear;
            this.searchCrit.listGroupeCouleur = data.colorGroups;
            this.searchCrit.listGroupeCouleurModele = data.colorGroups;
            if (this.modelSub != null) this.modelSub.unsubscribe();
            this.closeLoader();
        },
        error => {
            console.log(error);
            if (this.modelSub != null) this.modelSub.unsubscribe();
            this.closeLoader();
        });
        this.searchMixitCloudForm.controls["year"].setValue("");
        this.searchMixitCloudForm.controls["year"].enable();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * ClearModele
     * @param event
     */
    ClearModele(event: any) {
        this.searchMixitCloudForm.controls["model"].setValue("");
        this.searchMixitCloudForm.controls["year"].setValue("");
        this.searchMixitCloudForm.controls["year"].disable();
        this.searchCrit.listAnnee = [];
        this.searchCrit.listGroupeCouleur = this.searchCrit.listGroupeCouleurConstructeur;
        event.stopPropagation();
        this.searchCrit.selectedModele = false;
        this.searchCrit.selectedAnnee = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * SelectAnnee
     */
    SelectAnnee() {
        this.outputLangue.emit();

        this.searchCrit.selectedAnnee = true;
        this.openLoader();
        this.modelSub = this.apiService.updateFiltreMixiCloud(this.searchMixitCloudForm.value.colorCode, this.searchMixitCloudForm.value.manufacturer, this.searchMixitCloudForm.value.model, this.searchMixitCloudForm.value.year, this.searchMixitCloudForm.value.colorGroup, this.country, this.langue).subscribe(data => {
            ///*----------------------------------------------------------------------------------------------------*/console.log(data);
            this.searchCrit.listGroupeCouleur = data.colorGroups;
            this.searchCrit.listGroupeCouleurAnnee = data.colorGroups;
            if (this.modelSub != null) this.modelSub.unsubscribe();
            this.closeLoader();
        },
        error => {
            console.log(error);
            if (this.modelSub != null) this.modelSub.unsubscribe();
            this.closeLoader();
        });

    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * ClearAnnee
     * @param event
     */
    ClearAnnee(event: any) {
        this.searchMixitCloudForm.controls["year"].setValue("");
        this.searchCrit.listGroupeCouleur = this.searchCrit.listGroupeCouleurModele;
        event.stopPropagation();
        this.searchCrit.selectedAnnee = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * SelectGroupeCouleur
     */
    SelectGroupeCouleur() {
        this.outputLangue.emit();

        this.searchCrit.selectedGroupeCouleur = true;
        this.openLoader();
        this.modelSub = this.apiService.updateFiltreMixiCloud(this.searchMixitCloudForm.value.colorCode, this.searchMixitCloudForm.value.manufacturer, this.searchMixitCloudForm.value.model, this.searchMixitCloudForm.value.year, this.searchMixitCloudForm.value.colorGroup, this.country, this.langue).subscribe(data => {
            ///*----------------------------------------------------------------------------------------------------*/console.log(data);

            this.searchCrit.listConstructeur = data.brands;
            this.searchCrit.listModele = data.models;
            this.searchCrit.listAnnee = data.colorsUsedInYear;

            if (this.modelSub != null) this.modelSub.unsubscribe();
            this.closeLoader();
        },
        error => {
            console.log(error);
            if (this.modelSub != null) this.modelSub.unsubscribe();
            this.closeLoader();
        });

    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * ClearGroupeCouleur
     * @param event
     */
    ClearGroupeCouleur(event: any) {
        this.outputLangue.emit();

        this.searchMixitCloudForm.controls["colorGroup"].setValue("");
        event.stopPropagation();
        this.openLoader();
        this.modelSub = this.apiService.updateFiltreMixiCloud(this.searchMixitCloudForm.value.colorCode, this.searchMixitCloudForm.value.manufacturer, this.searchMixitCloudForm.value.model, this.searchMixitCloudForm.value.year, "", this.country, this.langue).subscribe(data => {
            ///*----------------------------------------------------------------------------------------------------*/console.log(data);

            this.searchCrit.listConstructeur = data.brands;
            this.searchCrit.listModele = data.models;
            this.searchCrit.listAnnee = data.colorsUsedInYear;

            if (this.modelSub != null) this.modelSub.unsubscribe();
            this.closeLoader();
        },
        error => {
            console.log(error);
            if (this.modelSub != null) this.modelSub.unsubscribe();
            this.closeLoader();
        });
        this.searchCrit.selectedGroupeCouleur = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * SelectApplication
     */
    SelectApplication() {
        this.searchCrit.selectedApplication = true;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * ClearApplication
     * @param teinte
     */
    ClearApplication(event: any) {
        this.searchMixitCloudForm.controls["application"].setValue("");
        event.stopPropagation();
        this.searchCrit.selectedApplication = false;
    }

    //#endregion Filtre

/* ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- */
/* Teinte accessoire */
/* ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- */

    //#region Teinte accessoire

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * SelectTeintesAccessoire
     * @param teinte
     */
    SelectTeintesAccessoire(teinte: Results) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function SelectTeintesAccessoire");
        ///*----------------------------------------------------------------------------------------------------*/console.log(this.selectedPart);
        this.outputLangue.emit();

        document.getElementById("errorlbl").style.visibility = "hidden";

        teinte.partNames.sort();

        this.searchCrit.lengthTotalSearchAccessoire = 0;
        this.searchCrit.positionInSearchAccessoire = 0;
        this.outputListApplicationAccessoire.emit(teinte.partNames);
        //this.listApplicationAccessoire = teinte.partNames;

        let listCodeTeinte = "";
        if (teinte.partColorRelations && teinte.partColorRelations.length > 0) {
            for (let i = 0; i < teinte.partColorRelations.length; i++) {
                listCodeTeinte += teinte.partColorRelations[i].colorCode + ((i == teinte.partColorRelations.length - 1) ? "" : ",");
            }

            ///*----------------------------------------------------------------------------------------------------*/console.log("this.searchMixitCloudForm.value.applicationAccessoire", this.searchMixitCloudForm.value.applicationAccessoire);
            ///*----------------------------------------------------------------------------------------------------*/console.log("this.selectedPart", this.selectedPart);
            ///*----------------------------------------------------------------------------------------------------*/console.log(listCodeTeinte);

            this.openLoader();
            this.searchSub = this.apiService.searchFormulesMeresMixitCloud(listCodeTeinte, "", "", "", "", this.country, this.langue, 0, true).subscribe(data => {
                ///*----------------------------------------------------------------------------------------------------*/console.log(data);
                ///*----------------------------------------------------------------------------------------------------*/console.log("this.teintesMeres", this.teintesMeres);
                ///*----------------------------------------------------------------------------------------------------*/console.log(data.results);

                this.searchCrit.positionInSearchAccessoire = data.results.length;

                /* A revoir quand liste accessoires disponible coté AKZO */
                var teintesMeresFiltrer: Results[] = [];
                for (var i = 0; i < data.results.length; i++) {
                    if ((data.results[i].codesCar && data.results[i].codesCar.length > 0)) {
                        teintesMeresFiltrer.push(data.results[i]);
                    }
                }
                data.results = teintesMeresFiltrer;

                this.teintesMeresAccessoire = data.results;

                for (var i = 0; i < this.teintesMeresAccessoire.length; i++) {
                    let item1 = teinte.partColorRelations.find(x => x.colorCode === this.teintesMeresAccessoire[i].akzoCode);
                    ///*----------------------------------------------------------------------------------------------------*/console.log("this.teintesMeresAccessoire[" + i + "].akzoCode", this.teintesMeresAccessoire[i].akzoCode);
                    ///*----------------------------------------------------------------------------------------------------*/console.log("item1", item1);
                    if (item1) {
                        this.teintesMeresAccessoire[i].partNames = item1.partNames;
                    }
                }

                this.searchCrit.lengthTotalSearchAccessoire = data.count;
                //this.searchCrit.positionInSearchAccessoire = data.results.length;
                if (data != null) {
                    this.resultTeintesMeresAccessoire.emit(teinte);
                    this.listResultTeintesMeresAccessoire.emit(data.results);
                    //this.outputSelectedPart.emit("tous");
                }
                else
                    document.getElementById("errorlbl").style.visibility = "visible";
                if (this.searchSub != null) this.searchSub.unsubscribe();
                this.closeLoader();
                ///*----------------------------------------------------------------------------------------------------*/console.log(this.teintesMeresAccessoire);
            },
            error => {
                console.log(error);
                if (this.searchSub != null) this.searchSub.unsubscribe();
                this.closeLoader();
            });
        }

    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * SelectApplicationAccessoire
     */
    SelectApplicationAccessoire(event: any) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function SelectApplicationAccessoire");
        this.outputSelectedPart.emit(event.value);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * ClearApplicationAccessoire
     */
    ClearApplicationAccessoire() {
        this.outputSelectedPart.emit("tous");
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * CompleteSearchAccessoire
     */
    CompleteSearchAccessoire() {
        document.getElementById("errorlbl").style.visibility = "hidden";

    }

    //#endregion Teinte accessoire

/* ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- */
/* MultiTon */
/* ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- */

    //#region MultiTon

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * SelectMultiTon
     * @param teinte
     */
    SelectMultiTon(teinte: Results) {
        this.outputLangue.emit();

        document.getElementById("errorlbl").style.visibility = "hidden";

        this.searchCrit.lengthTotalSearchMultiTon = 0;
        this.searchCrit.positionInSearchMultiTon = 0;

        let listCodeTeinte = "";
        if (teinte.combinationOf && teinte.combinationOf.length > 0) {
            for (let i = 0; i < teinte.combinationOf.length; i++) {
                listCodeTeinte += teinte.combinationOf[i] + ((i == teinte.combinationOf.length - 1) ? "" : ",");
            }

            ///*----------------------------------------------------------------------------------------------------*/console.log("this.searchMixitCloudForm.value.applicationAccessoire", this.searchMixitCloudForm.value.applicationAccessoire);
            ///*----------------------------------------------------------------------------------------------------*/console.log("this.selectedPart", this.selectedPart);
            ///*----------------------------------------------------------------------------------------------------*/console.log(listCodeTeinte);

            this.openLoader();
            this.searchSub = this.apiService.searchFormulesMeresMixitCloud(listCodeTeinte, "", "", "", "", this.country, this.langue, 0, true).subscribe(data => {
                ///*----------------------------------------------------------------------------------------------------*/console.log(data);
                ///*----------------------------------------------------------------------------------------------------*/console.log(data.results);

                this.searchCrit.positionInSearchMultiTon = data.results.length;

                /* aucun traitement sur la liste car pour récupérer la liste des teinte, on doit envoyer une liste de code AKZO donc on ne peux pas faire de rapprochement => rapporchement aussi impossible car pas la liste des teintes Ixell dans le retour du mutli */
                var teintesMeresFiltrer: Results[] = [];
                for (var i = 0; i < data.results.length; i++) {
                    //if (data.results[i].codesCar != null && data.results[i].codesCar != undefined && data.results[i].codesCar.length > 0) {
                    //    teintesMeresFiltrer.push(data.results[i]);
                    //}
                    if ((data.results[i].codesCar && data.results[i].codesCar.length > 0)) {
                        teintesMeresFiltrer.push(data.results[i]);
                    }

                }
                data.results = teintesMeresFiltrer;

                this.teintesMeresAccessoire = data.results;
                this.searchCrit.lengthTotalSearchMultiTon = data.count;
                //this.searchCrit.positionInSearchMultiTon = data.results.length;
                if (data != null) {
                    this.outputResultTeintesMeresMultiTon.emit(teinte);
                    this.outputListResultTeintesMeresMultiTon.emit(data.results);
                }
                else
                    document.getElementById("errorlbl").style.visibility = "visible";
                if (this.searchSub != null) this.searchSub.unsubscribe();
                this.closeLoader();
                ///*----------------------------------------------------------------------------------------------------*/console.log(this.teintesMeresAccessoire);
            },
                error => {
                    console.log(error);
                    if (this.searchSub != null) this.searchSub.unsubscribe();
                    this.closeLoader();
                });
        }

    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * CompleteSearchMultiTon
     */
    CompleteSearchMultiTon() {
        document.getElementById("errorlbl").style.visibility = "hidden";

    }

    //#endregion MultiTon

/* ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- */
/* Autre */
/* ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- */

    //#region Autre

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * openLoader
     */
    openLoader() {
        let modal = document.getElementById("loadingModal");
        modal.style.display = "flex";
        if (document.activeElement instanceof HTMLElement)
            document.activeElement.blur();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * closeLoader
     */
    closeLoader() {
        let modal = document.getElementById("loadingModal");
        modal.style.display = "none";
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * launchColorwebtech
     * */
    launchColorwebtech(event: any) {
        if (event.value == "ixell" || event.value == "oxelia") {
            this.headerService.changeTitle("ColorWebtech");
            this.headerService.changeCanBack(false);
            this.router.navigate(["colorwebtech"], { queryParams: { tech: event.value } });
        }
    }

    //#endregion Autre

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * ngOnDestroy
     */
    ngOnDestroy(): void {
        if (this.colorSub != null) this.colorSub.unsubscribe();
        if (this.manufacturerSub != null) this.manufacturerSub.unsubscribe();
        if (this.modelSub != null) this.modelSub.unsubscribe();
        if (this.searchSub != null) this.searchSub.unsubscribe();
    }

}
